import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { clearAll } from "utils";
import { useUser } from "./useUser";

export const useHeader = () => {
  const { user } = useUser();
  const [isHeaderMenuOpen, setIsHeaderMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleHeaderMenuToggle = () => {
    setIsHeaderMenuOpen((prev) => !prev);
  };

  const handleLogout = () => {
    clearAll();
    setIsHeaderMenuOpen(false);
  };

  const handleNavigate = (path: string) => {
    navigate(path);
    setIsHeaderMenuOpen(false);
  };

  return {
    isHeaderMenuOpen,
    handleHeaderMenuToggle,
    handleLogout,
    handleNavigate,
    user,
  };
};
